var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonActions, CommonStates } from '../../../localization/helpers.js';
let AddAndInfo = class AddAndInfo extends LitElement {
    constructor() {
        super(...arguments);
        this.selectedPoi = null;
    }
    handleAddEditPoi(mode) {
        this.dispatchEvent(new CustomEvent('add-edit-poi', {
            detail: {
                selectedNetwork: this.selectedNetwork,
                selectedPoi: mode === "edit" ? this.selectedPoi : null
            },
            bubbles: true,
            composed: true,
        }));
    }
    handleDeletePoi() {
        if (!this.selectedPoi)
            return;
        this.dispatchEvent(new CustomEvent('delete-poi', {
            detail: this.selectedPoi,
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        if (!this.selectedNetwork) {
            return html `<div>${CommonStates.loading()}</div>`;
        }
        return html `
    <basic-card class="container">
      <div class="buttons">
        <simple-button
          label=${msg('Add a point', { id: 'network.poi.addPoint', desc: 'Add point button' })}
          variant="primary"
          special
          @button-click="${() => this.handleAddEditPoi("add")}"
        ></simple-button>
        ${this.selectedPoi
            ? html `
              <simple-button
                label=${msg('Edit point', { id: 'network.poi.editPoint', desc: 'Edit point button' })}
                variant="secondary"
                @button-click="${() => this.handleAddEditPoi("edit")}"
              ></simple-button>
              <simple-button
                label=${CommonActions.delete()}
                variant="danger"
                @button-click="${this.handleDeletePoi}"
              ></simple-button>
            `
            : null}
      </div>
      <div class="info-text">
        ${msg('Created by', { id: 'network.info.createdBy', desc: 'Created by label' })} ${this.selectedNetwork.created_by} ${msg('on', { id: 'network.info.on', desc: 'on (date)' })}
        ${new Date(this.selectedNetwork.created_at).toLocaleDateString()} -
        ${msg('Last modified on', { id: 'network.info.lastModified', desc: 'Last modified label' })}
        ${new Date(this.selectedNetwork.updated_at).toLocaleDateString()}
      </div>
      </basic-card>
    `;
    }
};
AddAndInfo.styles = css `
    :host {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      }
      
      basic-card.container {
        padding: 10px 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
      }

    .add-point,
    .edit-point,
    .delete-point {
      padding: 8px 12px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition:
        background 0.3s,
        box-shadow 0.3s;
    }

    .add-point {
      background: #0078d4;
    }

    .add-point:hover {
      background: #005a9e;
    }

    .edit-point {
      background: #1c95ff;
    }

    .edit-point:hover {
      background: #0078d4;
    }

    .delete-point {
      background: #ff4d4d;
    }

    .delete-point:hover {
      background: #d93636;
    }

    .info-text {
      font-size: 12px;
      color: #666;
      text-align: right;
    }

    .buttons {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  `;
__decorate([
    property({ type: Object })
], AddAndInfo.prototype, "selectedNetwork", void 0);
__decorate([
    property({ type: Object })
], AddAndInfo.prototype, "selectedPoi", void 0);
AddAndInfo = __decorate([
    localized(),
    customElement('add-and-info')
], AddAndInfo);
export { AddAndInfo };
//# sourceMappingURL=AddAndInfo.js.map